module.exports = __webpack_public_path__ + "img/img-4.370b44d2.jpg";